import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class FengChao extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner fc_banner">
          <div className="banner_cont">
            <h1>指标计算平台 – 蜂巢</h1>
            <p>变量计算平台蜂巢致力于轻量化打造统一的变量体系，提供高效的实时变量计算服务，实现变量便捷管理和应用。蜂巢适用于多种场景，业务专家可根据不同的需要，如决策模型、机器学习等，在蜂巢自主配置和开发变量。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel fc_panel">
            <h2><span>指标计算全流程支持</span></h2>
            <img className="fc_img" src={require('./images/pro_15.png')}/>
          </div>
        </div>
        <div className="wrapPanel fa_wrap">
          <div className="panel fc_panel">
            <h2><span>应用场景</span></h2>
            <ul className="apply_ul_fc">
              <li>
                <img src={require('./images/pro_16.png')}/>
                <h3>决策模型</h3>
                <p>包含但不限于评分卡、决策表、PMML模型、机器学习等决策模型</p>
              </li>
              <li>
                <img src={require('./images/pro_17.png')}/>
                <h3>规则包</h3>
                <p>包含但不限于反欺诈规则、进件规则、数据筛选规则等规则包</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel pro_panel_wl">
            <h2><span>产品优势</span></h2>
            <ul className="pro_ul">
              <li>
                <img src={require('./images/icon_5.png')}/>
                <p className="title">零编码</p>
                <p>可以自主配置数据源，通过SQL开发不同场景的变量，支持变量批量定义和批量开发</p>
              </li>
              <li>
                <img src={require('./images/icon_6.png')}/>
                <p className="title">统一变量管理</p>
                <p>统一变量管理，支持多人协同定义，共享资料库，为各种场景提供变量数据服务</p>
              </li>
              <li>
                <img src={require('./images/icon_7.png')}/>
                <p className="title">实时计算服务</p>
                <p>实时计算，能够为配置的各种业务场景提供毫秒级的变量计算服务</p>
              </li>
            </ul>
            <ul className="pro_ul">
              <li>
                <img src={require('./images/icon_5.png')}/>
                <p className="title">监控配置化</p>
                <p>可视化配置需监控的变量和场景，对变量效果进行跟踪和分析， 并对异常进行告警</p>
              </li>
              <li>
                <img src={require('./images/icon_6.png')}/>
                <p className="title">集成多种征信数据</p>
                <p>可以集成人行报告、通话详单、社保、公积金等各种征信数据</p>
              </li>
              <li>
                <img src={require('./images/icon_7.png')}/>
                <p className="title">本地化解决方案</p>
                <p>产品部署在客户本地机器，数据只在内网流转，避免数据外泄</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


export default FengChao



// WEBPACK FOOTER //
// ./modules/services/FengChao.js